/**
 * Main App Component
 * Sets up routing and navigation for the application
 *
 * Requirements: 1.5, 2.4, 9.1, 9.2
 */

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getCustomStyles } from './styles/customStyles';

// Context providers
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';

// UI primitives
import Toast from './components/ui/Toast';

// Routing helpers
import ProtectedRoute from './components/routing/ProtectedRoute';
import DashboardGate from './components/routing/DashboardGate';

// Public pages (legacy — frozen)
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';

// Role spaces
import TutorSpace from './pages/tutor/TutorSpace';
import AdminSpace from './pages/admin/AdminSpace';

const App = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <style>{getCustomStyles()}</style>
          <Toast />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* /dashboard — post-login gate (parent: legacy Dashboard; admin/tutor: redirect) */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardGate />
                </ProtectedRoute>
              }
            />

            {/* Tutor space */}
            <Route
              path="/app/tuteur/*"
              element={
                <ProtectedRoute requiredRole="tutor">
                  <TutorSpace />
                </ProtectedRoute>
              }
            />

            {/* Admin space */}
            <Route
              path="/app/admin/*"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminSpace />
                </ProtectedRoute>
              }
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
